export default __webpack_public_path__ + "static/media/arrow-down.a90ce2c4.svg";